import { axiosDS } from '@pp/axios'
import { RequestParams, ResponseCatalog } from 'Models'
import { urls } from 'Src/constants/Urls'
import { RbidosRequest } from 'Pages/registratorCabinet'

export const orderListApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<RbidosRequest>>(urls.cabinet.rbidosRequest, {
			params,
		})
		return res.data
	},
	infotecsLogin: async (data: Record<string, string>) => {
		const res = await axiosDS().post<{ result: string }>(urls.cabinet.infotecsLogin, { data })
		return res.data
	},
	deleteInfotecsLogin: async () => {
		const res = await axiosDS().delete<Record<string, string>>(urls.cabinet.infotecsLogin)
		return res.data
	},
}
